module.exports = __webpack_public_path__ + "assets/171a58a4b5d7385df64d7ce1a249b7f7.mp4";